import { render, staticRenderFns } from "./studioadd.vue?vue&type=template&id=66a93dd8"
import script from "./studioadd.vue?vue&type=script&lang=js"
export * from "./studioadd.vue?vue&type=script&lang=js"
import style0 from "./studioadd.vue?vue&type=style&index=0&id=66a93dd8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports